import { render, staticRenderFns } from "./SubPortalButton.vue?vue&type=template&id=6012ac7a&"
import script from "./SubPortalButton.vue?vue&type=script&lang=js&"
export * from "./SubPortalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports